import React from 'react'
import { useFormState } from 'react-final-form'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import Container, { Content, Header } from '~/components/Container'
import PageTitle from '~/components/PageTitle'
import { DiscardButton, SaveButton } from '~/components/Buttons'
import { withForm } from '~/components/Form'
import { BackgroundSingleFileUpload } from '~/components/BackgroundFileUpload'
import { TemplateCard } from '~/components/FileUpload'
import * as API from '~/constants/api'
import * as NAV from '~/constants/nav-titles'
import ProgressCard from '~/components/ProgressCard'
import { useGoogleEvent } from '~/components/GoogleAnalytics/GoogleAnalytics'

import UploadedFile from './UploadedFile'

function WarehouseImport ({ title, form, isLoading, progressCard, onSubscribe, onFileRemove }) {
  const { handleSubmit } = form
  const { sendEvent } = useGoogleEvent()
  const formState = useFormState()

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            pageTitle={title}
            parentTitle={NAV.WAREHOUSE}
            rightButton={(
              <>
                <DiscardButton disabled={isLoading} />
                <SaveButton disabled={isLoading || !formState.values.file} />
              </>
            )}
          />
        </Header>

        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12} lg={8}>
              <BackgroundSingleFileUpload
                name="file"
                api={API.WAREHOUSE_FILE_VALIDATE}
                onSubscribe={onSubscribe}
                Component={UploadedFile}
                onFileRemove={onFileRemove}
              />
            </Grid>
            <Grid item={true} xs={12} lg={4}>
              <Grid container={true} spacing={3}>

                <Grid item={true} xs={12}>
                  <TemplateCard
                    fileName="Warehouses.xlsx"
                    onClick={() => sendEvent({
                      eventAction: 'Template File Download Location',
                      eventCategory: 'Location'
                    })}
                  />
                </Grid>
                <Grid item={true} xs={12}>
                  <ProgressCard
                    title="Progress"
                    validation={progressCard.validation}
                    completion={progressCard.completion}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

WarehouseImport.propTypes = {
  form: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  progressCard: PropTypes.object.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired
}

export default withForm(WarehouseImport)
